/**
 * Admin Header Layout structure UI
 */
import { useState } from 'react';
import { Outlet } from 'react-router-dom';

//------------------------------------------------
import { LayoutRoot, LayoutMain } from './dashboardStyles';
import Header from './adminHeader';
import Nav from './adminSidebar';

/**
 * @returns Admin Dashboard layout UI
 */
export default function DashboardAdminLayout() {
  const [open, setOpen] = useState(false);

  return (
    <LayoutRoot>
      <Header onOpenNav={() => setOpen(true)} />
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <LayoutMain>
        <Outlet />
      </LayoutMain>
    </LayoutRoot>
  );
}
